import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { apiGet, apiPost } from 'tennders-stracture/libs/api'
import { useToast } from 'tennders-common/hooks/useToast'
import { StateType } from 'tennders-common/types/StateType'
import { REDUX_MODAL_TYPES } from 'tennders-common/stores/modal/action'

const useAssignTo = (type = 'broker', multiple = true) => {
  const { t } = useTranslation()
  const { toastSuccess, toastError } = useToast()
  const dispatch = useDispatch()

  const [assignedUsers, setassignedUsers] = useState([])

  const assignReducer = useSelector((state : StateType) => state.modal.assignTo)
  const [assignTo, assignType, allowMultipleAssign] = Array.isArray(assignReducer)
    ? assignReducer : [false, 'broker', true]
  const canBeAssignedMultiple = allowMultipleAssign
  const setAssignTo = (transactionId) => {
    dispatch({
      type: REDUX_MODAL_TYPES.ASSIGN_TO,
      payload: [transactionId, type, multiple]
    })
  }

  const useType = assignType || type

  const fetchAssignedUsers = async (transactionId) => {
    const response = await apiGet(`transactions/${transactionId}/assign-to/${useType}`)
    setassignedUsers(response)
  }

  const submitAssignTo = async (transactionId, params) => {
    const response = await apiPost(`transactions/${transactionId}/assign-to/${useType}`, params)
    if (response && response.error) {
      toastError(response.error)
    } else {
      toastSuccess(t('toast:assigned'))
      setAssignTo(false)
    }
  }

  return {
    submitAssignTo,
    assignTo,
    fetchAssignedUsers,
    assignedUsers,
    setAssignTo,
    canBeAssignedMultiple
  }
}

export default useAssignTo
